var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChnagedDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    y: 0.986,
    fill: "#1E0AF5",
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.75 10.153h-7.5m5.417-3.333v1.666M8.333 6.82v1.666m-.083 6.667h3.5c.7 0 1.05 0 1.318-.136a1.25 1.25 0 0 0 .546-.546c.136-.268.136-.618.136-1.318v-3.5c0-.7 0-1.05-.136-1.317a1.25 1.25 0 0 0-.546-.547c-.268-.136-.618-.136-1.318-.136h-3.5c-.7 0-1.05 0-1.317.136a1.25 1.25 0 0 0-.547.547c-.136.267-.136.617-.136 1.317v3.5c0 .7 0 1.05.136 1.318.12.235.311.426.547.546.267.136.617.136 1.317.136Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5.986h10v10H5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChnagedDate);
export default __webpack_public_path__ + "static/media/chnaged-date.8906bd1b4da97a369fed038ea4d855ed.svg";
export { ForwardRef as ReactComponent };